import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './PurchaseCreateUserAlert.module.scss';

interface Props {
  className?: string;
  onClick: () => void;
}

const PurchaseCreateUserAlert = ({
  className,
  intl,
  onClick,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseCreateUserAlert, className);

  return (
    <div className={classes}>
      <p className={css.PurchaseCreateUserAlert__Paragraph}>
        {intl.formatMessage({
          id: 'purchases.purchaseCreateUserAlert.message1',
        })}
      </p>
      <p className={css.PurchaseCreateUserAlert__Paragraph}>
        <FormattedMessage
          id="purchases.purchaseCreateUserAlert.message2"
          values={{
            login: (
              <a
                onClick={onClick}
                className={css.PurchaseCreateUserAlert__Link}
              >
                {intl.formatMessage({
                  id: 'purchases.purchaseCreateUserAlert.here',
                })}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(PurchaseCreateUserAlert);
